import { faSave } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useEffect, useState } from "react"
import ReactQuill from "react-quill"
import { useParams } from "react-router-dom"
import PulseLoader from "react-spinners/PulseLoader"
import { useUpdateMultiGradeMutation } from "../responses/responsesApiSlice"
import { useGetTasksQuery } from "../tasks/tasksApiSlice"

function EditMultiGrade() {
    const {groupId} = useParams()
    const [grade,setGrade] = useState(100)
    const [notes,setNotes] = useState('')
    const [count,setCount] = useState('')
    const [checkAll, setCheckAll] = useState(false)
    const [checkedTasks, setCheckedTasks] = useState([]);
    const {
        data: tasks,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetTasksQuery('tasksList', {
        // pollingInterval: 15000,
        // refetchOnFocus: true,
        //refetchOnMountOrArgChange: true
    })



    const [updateMulti, {
        data: updateData,
        isLoading:isLoadingUpdate,
        isSuccess :isSuccessUpdate,
        isError: isErrorUpdate,
        error: errorUpdate
    }] = useUpdateMultiGradeMutation()

    useEffect(() => {

        if (isSuccessUpdate) {
            setCheckedTasks([])
            setGrade(100)
            setCount(updateData)
        }

    }, [isSuccessUpdate])

    let filteredIds = []
    let content
    if (isLoading) content = <PulseLoader color={"#FFF"} />

    if (isError) {
        content = <p className="errmsg">{error?.data?.message}</p>
    }
    const changeSelected = (checked, taskId) =>{
        if(checked)
            setCheckedTasks([...checkedTasks, taskId])
        else
            setCheckedTasks([...checkedTasks.filter(t=> t!= taskId)])
        setCount('')
    }
    const changeSelectedAll = () =>{
        if(!checkAll)
            setCheckedTasks([...filteredIds])
        else
            setCheckedTasks([])
        setCheckAll(!checkAll)
        setCount('')
    }

    const updateMultiClick = async () =>{
        await updateMulti({ tasks: checkedTasks, grade, notes })
        
    }

    if (isSuccess ) {
        const { ids, entities } = tasks
       
        if(groupId!=='0'){
            filteredIds=[...ids].filter(taskId =>{
                const task =  entities[taskId]
             return task.group === groupId 

            })
        }else
            {
                filteredIds = [...ids]
            }
       
       

        const tableContent = ids?.length && filteredIds.map(taskId => <tr className="table__row" key={taskId}>
            <td className={`table__cell`}><input checked={checkedTasks.indexOf(taskId) > -1}  className="form__checkbox" id={`cb_${taskId}`} onChange={(e)=>changeSelected(e.target.checked,taskId)} type="checkbox" /><label htmlFor={`cb_${taskId}`} >{entities[taskId].title} <div className="text-sm">{entities[taskId].groupname}</div> </label></td>
            <td className={`table__cell quill-max-height-250`}>
            <ReactQuill
                     theme='bubble'
                    readOnly
                    value={entities[taskId].body}
                    
                    ></ReactQuill>
               </td>
        </tr>)

        content = (
            <>

<form className="form"  onSubmit={e => e.preventDefault()}>
                


         
            {(count) && <h3>עודכנו {count} ציונים</h3>}
                <div className="form__title-row">
                   
                     <h2>עדכון ציון מרובה משתמשים למשימות ללא ציון</h2>
                     <div className="form__action-buttons">

                     <button
                            className="icon-button"
                            title="Save"
                            onClick={updateMultiClick}
                            disabled={!checkedTasks.length || !grade || isLoadingUpdate}
                        >
                            <FontAwesomeIcon icon={faSave} />
                        </button>
                        </div>
                        
                    
                </div>
                <label className="form__label" htmlFor="grade">
                    ציון:</label>
                <input
                    className={`form__input  ${!grade &&'form__input--incomplete'}`}
                    id="grade"
                    name="grade"
                    type="number"
                    autoComplete="off"
                    value={grade}
                    onChange={(e)=>setGrade(e.target.value)}
                />
    
                <div className="form__row">
                <label className="form__label" htmlFor="notes">
                    הערות בודק</label>   
                        </div>

                        <ReactQuill
                     value={notes}
                    onChange={setNotes}
                    modules={{
                        toolbar: [
                          [{ 'header': '1'}, {'header': '2'}, {'font': []}],
                         // [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
                          [{ 'align': [] }],
                          [{ 'direction': 'rtl' }],   
                          [{size: []}],
                          [{ color: [] }, { background: [] }],
                          ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                          [{'list': 'ordered'}, {'list': 'bullet'}/*,       {'indent': '-1'}, {'indent': '+1'}*/],
                          ['link'],
                          ['clean']
                        ],
                        clipboard: {
                          matchVisual: false,
                        }
                      }}
                    />

                 {/* <textarea
                    className={`form__input   `}
                    id="notes"
                    name="notes"
                    value={notes}
                    onChange={(e)=>setNotes(e.target.value)}
                />               */}

               
           
         
            </form>


            
            <table className={`table table--multi-grade`}>
                <thead className="table__thead">
                    <tr>                       
                        <th scope="col" className="table__th task__title">
                        <input onChange={changeSelectedAll} id="cb_all" className="form__checkbox" type="checkbox" /> <label htmlFor="cb_all">
                            משימה
                            </label>
                            </th>
                        <th scope="col" className="table__th task__body">תוכן</th>
                    </tr>
                </thead>
                <tbody>
                    {tableContent}
                </tbody>
            </table>
            </>
        )
    }
   

    return content
}

export default EditMultiGrade